import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="grain flex min-h-screen items-center justify-center bg-[#09090B] px-5">
      <div className="w-full max-w-md border border-zinc-800 bg-surface-100 p-10 text-center">
        <h1 className="font-display text-5xl uppercase leading-none tracking-tight">
          Checkout
          <br />
          <span className="text-zinc-600">paused.</span>
        </h1>
        <p className="mt-4 text-base leading-relaxed text-zinc-400">
          No worries — nothing was charged. Your God Mode is still waiting. The
          crash isn't going anywhere; neither should you.
        </p>
        <Link
          to="/"
          data-testid="cancel-back-btn"
          className="mt-8 inline-flex items-center gap-2 bg-blaze px-8 py-4 font-mono text-sm font-bold uppercase tracking-[0.12em] text-black transition-transform duration-200 hover:-translate-y-1"
        >
          <ArrowLeft className="h-4 w-4" /> Finish my order
        </Link>
      </div>
    </div>
  );
}
